import { useEffect, useRef } from 'react';

const GZ_META_PIXEL_ID = '1539167620549880';

export function useGZConsentGatedMetaPixel(consentGranted: boolean): void {
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    if (hasLoadedRef.current) return;
    if (!consentGranted) return;

    hasLoadedRef.current = true;

    // Standard Meta Pixel initialization - creates fbq function before script loads
    // This matches the official Meta Pixel snippet behavior
    const fbq = function (...args: unknown[]) {
      fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
    } as unknown as {
      (...args: unknown[]): void;
      callMethod?: (...args: unknown[]) => void;
      loaded: boolean;
      push: typeof fbq;
      queue: unknown[][];
      version: string;
    };

    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    // @ts-expect-error - adding fbq to window
    window.fbq = fbq;
    // @ts-expect-error - adding _fbq to window
    if (!window._fbq) window._fbq = fbq;

    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.async = true;
    document.head.appendChild(script);

    fbq('init', GZ_META_PIXEL_ID);
    fbq('track', 'PageView');
  }, [consentGranted]);
}
